import { mergeStyles } from "@uifabric/styling";
import { memoizeFunction } from "@uifabric/utilities";
var getClassNames = memoizeFunction(function (styles, className) {
    return {
        root: mergeStyles("dashboard", className, styles.root),
        overlay: mergeStyles("dashboard-overlay", styles.overlay),
        content: mergeStyles("dashboard-content", styles.content)
    };
});
export { getClassNames };
